<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import { useLayoutStore } from '@/stores/layout'
import { useRoute } from 'vue-router'

// Lazy-load DesktopLayout so it (and all its transitive imports) are only
// evaluated after Pinia is active - not at App.vue module evaluation time.
const DesktopLayout = defineAsyncComponent(() => import('@/components/layout/DesktopLayout.vue'))

const layoutStore = useLayoutStore()
const route = useRoute()

// Only use desktop shell on authenticated routes
const isAuthRoute = () => !!(route.meta as Record<string, unknown>).requiresAuth
</script>

<template>
  <DesktopLayout v-if="layoutStore.mode === 'desktop' && isAuthRoute()">
    <slot />
  </DesktopLayout>
  <slot v-else />
</template>
